import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tln-hr-logo',
  styleUrl: './hr-logo.component.less',
  templateUrl: './hr-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class HrLogoComponent {}
